module.exports = __webpack_public_path__ + "static/pigly05-f4add8e0d20f8097d0c3ac702d33ebe4.png";